<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  status: { type: String, required: true },
});

const store = useStore();
const labels = computed(() => store.getters['painel/getStatusLabels']);
const colors = computed(() => store.getters['painel/getStatusColors']);

const label = computed(() => labels.value[props.status] || props.status);
const colorClass = computed(() => {
  const c = colors.value[props.status] || 'slate';
  const map = {
    teal: 'bg-n-teal-3 text-n-teal-12 border-n-teal-7',
    ruby: 'bg-n-ruby-3 text-n-ruby-12 border-n-ruby-7',
    amber: 'bg-n-amber-3 text-n-amber-12 border-n-amber-7',
    slate: 'bg-n-slate-3 text-n-slate-12 border-n-slate-7',
    blue: 'bg-n-blue-3 text-n-blue-12 border-n-blue-7',
  };
  return map[c] || map.slate;
});
</script>

<template>
  <span
    class="inline-block rounded-full border px-2.5 py-0.5 text-xs font-semibold"
    :class="colorClass"
  >
    {{ label }}
  </span>
</template>
